export default {
  app: {
    privacy: {
      policy: 'patakaran sa privacy',
      expansive: 'Sa paggamit ng Expansive, sumasang-ayon ka sa {action} ng Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Nag-expire ang sesyon',
    sessionExpiredDescription:
      'Nag-expire na ang iyong sesyon. Mangyaring mag-login muli upang ipagpatuloy ang paggamit ng application.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Pumili ng wika',
      chooseLanguageDescription:
        'Pumili ng nais mong wika para sa application. Babaguhin nito ang wika ng interface at nilalaman.',
    },
    userSelection: {
      cancel: 'Kanselahin',
      createNewUser: 'Hindi nakalista ang kanilang pangalan',
      newUser: 'Bagong user',
      selectAnExistingUser: 'Pumili ng umiiral na user',
      selectUserHint: 'Pumili ng umiiral na user o gumawa ng bago upang magpatuloy.',
      startTypingToSearch: 'Simulan ang pag-type...',
    },
    verification: {
      codeVerification: {
        continue: 'Magpatuloy',
        header: 'Ilagay ang site access code',
        invalidCode: 'Maling code, subukan muli.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Magpatuloy nang hindi tinitiyak ang lokasyon',
        enterSiteAccessCode: 'Ilagay ang site access code',
        locationNotEnabledOrAvailable: 'Bakit nakikita ko ito?',
        notAvailable: {
          description: 'Ang lokasyon ng GPS ay hindi sinusuportahan sa device na ito.',
          header: 'Ang lokasyon ay hindi sinusuportahan',
        },
        notEnabled: {
          description:
            'Ang mga serbisyo ng lokasyon ay hindi naka-enable o hindi naibigay ang pahintulot.',
          header: 'Ang lokasyon ay hindi naka-enable',
        },
        notVerified: {
          description: 'Ipinapakita ng GPS na hindi ka nasa site.',
          header: 'Hindi napatunayan ang lokasyon',
        },
        tryAgain: 'Subukan muli',
        unavailable: {
          description: 'Hindi namin napatunayan ang iyong lokasyon sa GPS.',
          header: 'Hindi available ang lokasyon',
        },
        unknown: {
          description: 'Hindi namin matukoy ang iyong lokasyon.',
          header: 'Hindi alam ang lokasyon',
        },
        verified: {
          description: 'Ipinapakita ng GPS na ikaw ay nasa site.',
          header: 'Napatunayan ang lokasyon',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Walang nahanap na asset',
        emptyDescription: 'Walang asset na nauugnay sa work order na ito.',
        warrantyParts: 'Magtatapos ang warranty ng mga piyesa',
        serialNumber: 'Serial number',
        none: '<wala>',
      },
      updates: {
        emptyTitle: 'Walang nahanap na update',
        emptyDescription: 'Walang update para sa work order na ito.',
        unknownUser: 'Hindi kilalang user',
        none: 'Wala',
        addComment: {
          buttonLabel: 'Magdagdag ng komento',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Mga panganib',
          no: 'Hindi',
          yes: 'Oo',
        },
      },
    },
    attachmentsList: {
      attachments: 'Mga kalakip',
      documents: 'Mga dokumento',
      siteDocuments: 'Mga dokumento ng site',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Mga panganib',
        induction: 'Induction',
        safeToProceed: 'Ligtas magpatuloy',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Petsa ng pagtatapos',
        activeSessions: 'Aktibong mga sesyon',
        activeSessionsDescription:
          'Naka-check in ka na sa mga sumusunod na work order. Kailangan mong mag-check out sa mga ito bago mag-check in sa panibagong work order.',
        resumeSession: 'Ipagpatuloy',
        startTime: 'Nagsimula noong',
        unexpectedErrorTitle: 'Hindi inaasahang error',
        unexpectedErrorMessage:
          'Nagkaroon ng hindi inaasahang error habang sinusubukang gawin ang iyong mga sesyon. Subukan muli mamaya.',
        engineerNotFound: 'Hindi nahanap ang engineer',
        engineerNotFoundDescription:
          'Ang engineer na sinusubukan mong i-check in ay hindi nahanap sa sistema. Mangyaring makipag-ugnayan sa iyong administrator.',
      },
      verification: {
        code: {
          description:
            'Upang mag-check in, kunin ang 4-digit code mula sa site manager o itinalagang contact.',
        },
        geo: {
          continue: 'Magpatuloy',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Mangyaring kunin ang access code mula sa site manager o itinalagang contact para makumpleto ang iyong pagbisita.',
            checkOut: 'Mag-check out',
            completeBeforeLeaving: 'Pakikumpleto ang sumusunod na form bago umalis.',
            continue: 'Magpatuloy',
            noResolutionSelected: 'Pumili ng resolusyon bago magpatuloy.',
            quoteRequired: {
              hint: 'Tapos na ang pagbisita, susunod ang quote',
              label: 'Kailangan ng quote',
            },
            returnVisitRequired: {
              hint: 'Babalik kami upang tapusin',
              label: 'Kailangan ng muling pagbisita',
            },
            serviceCompleted: {
              hint: 'Wala nang kailangang gawin',
              label: 'Tapos na ang serbisyo',
            },
            uploadCheckout: 'Mag-upload ng file, larawan, o video',
            visitNotes: 'Mga tala ng pagbisita',
            workOrderResolution: 'Resolusyon ng work order',
            enterNotes: 'Ilagay ang anumang tala dito...',
            errors: {
              timedOut: 'Oras ay lumipas, lumampas ng 30 segundo. Pakisubukang muli.',
              closingSession: 'Error sa pagsasara ng sesyon',
            },
          },
          success: {
            description:
              'Salamat sa pagbisita sa {site}. | {site} ay may 1 natitirang bukas na work order. | {site} ay may {count} natitirang bukas na work order.',
            endVisit: 'Tapusin ang pagbisita',
            header: 'Matagumpay kang naka-check out',
            viewWorkOrders: 'Mag-check in sa ibang work order',
          },
          verification: {
            code: {
              description:
                'Upang mag-check out, kunin ang 4-digit code mula sa site manager o itinalagang contact.',
              continue: 'Magpatuloy',
            },
            geo: {
              checkOut: 'Mag-check out',
              continue: 'Magpatuloy',
            },
          },
        },
        detail: {
          assets: 'Mga asset',
          call: 'Tumawag',
          checkOut: 'Mag-check out',
          closed: 'Sarado',
          details: 'Mga detalye',
          dueBy: 'Petsa ng pagtatapos',
          manageEngineers: 'Pamahalaan ang mga engineer',
          notAvailable: 'Hindi available',
          pointOfContact: 'Punto ng kontak',
          siteAccessTimes: 'Oras ng access sa site',
          siteAccessInstructions: 'Mga tagubilin sa pag-access',
          siteAddress: 'Address ng site',
          siteNotes: 'Mga tala ng site',
          siteTelephone: 'Telepono ng site',
          siteLocation: 'Lokasyon ng site',
          updates: 'Mga update',
          more: 'Higit pa',
          mismatchErrorTitle: 'Error sa work order',
          mismatchErrorMessage:
            'Ang work order na sinusubukan mong buksan ay hindi tumutugma sa kasalukuyan mong naka-check in. Pakisuri ang iyong work order at subukan muli.',
          siteDocuments: 'Mga dokumento ng site',
          validFrom: 'Simula',
          validUntil: 'Hanggang',
          documentName: 'Pangalan ng dokumento',
          documentType: 'Uri ng dokumento',
          attachments: 'Mga file ng work order',
          download: 'I-download',
          workDetails: 'Mga detalye ng trabaho',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Magdagdag ng assistant engineer',
            assistantEngineers: 'Mga assistant engineer',
            description: 'Para sa seguridad, ilista ang pangalan ng bawat engineer sa site.',
            editMainEngineer: 'I-edit ang pangunahing engineer',
            errors: {
              creatingEngineer: 'Error sa paglikha ng engineer',
              creatingSession: 'Error sa paglikha ng sesyon',
            },
            header: 'Mga engineer sa site',
            mainEngineer: 'Pangunahing engineer',
            newAssistantEngineer: 'Ilagay ang kanilang buong pangalan',
            next: 'Susunod',
            removeEngineer: 'Tanggalin ang engineer',
            selectExistingAssistantEngineer: 'Simulan ang pag-type ng kanilang pangalan',
          },
          index: {
            description: 'Para sa seguridad, ilista ang pangalan ng bawat engineer sa site.',
            errorCreatingEngineer: 'Error sa paglikha ng engineer, subukan muli.',
            header: 'Mga engineer sa site',
            hintMainEngineer: 'Ilagay ang buong pangalan ng pangunahing engineer',
            newMainEngineer: 'Bagong pangunahing engineer',
            next: 'Susunod',
            selectExistingMainEngineer: 'Pumili ng umiiral na pangunahing engineer',
            yes: 'Oo',
            no: 'Hindi',
            mainEngineerLabel: 'Ikaw ba ang pangunahing engineer?',
          },
        },
        index: {
          callUsOn: 'Tumawag sa {phoneNumber}',
          description: 'Hindi mo mahanap ang iyong hinahanap?',
          dueBy: 'Petsa ng pagtatapos',
          header: 'Pumili ng work order',
          notAvailable: 'Hindi available',
          searchWorkOrders: 'Maghanap ng work order...',
        },
        manageEngineers: {
          manageEngineers: 'Pamahalaan ang mga engineer',
          notWorking: 'Hindi aktibong manggagawa',
          pause: 'I-pause',
          resume: 'Ipagpatuloy',
          workingNow: 'Aktibong manggagawa',
          startTime: 'Oras ng simula',
          endTime: 'Oras ng pagtatapos',
          duration: 'Tagal',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription:
              'Magbigay ng feedback tungkol sa work order upang mapabuti pa namin ang aming serbisyo.',
            feedbackLabel: 'Feedback',
            filesLabel: 'Mga kalakip',
            submissionLabel: 'Isumite ang feedback',
          },
          hazards: {
            back: 'Bumalik',
            hazards: 'Mga panganib',
            next: 'Susunod',
            no: 'Hindi',
            noTasksForHazard: 'Walang gawain para sa panganib na ito.',
            yes: 'Oo',
          },
          induction: {
            continue: 'Magpatuloy',
            induction: 'Induction',
          },
          index: {
            checkIn: 'Mag-check in',
            description: 'Pakikumpleto ang sumusunod na risk assessment para sa napiling trabaho.',
            fail: 'Nabigong iproseso ang start work order checks.',
            haltMessage:
              'May natukoy na potensyal na panganib. Itigil ang trabaho, suriin ang mga patakaran sa kaligtasan, at makipag-ugnayan sa iyong superbisor para sa karagdagang tagubilin.',
            header: 'Mga pagsusuri bago simulan ang trabaho',
            endVisit: 'Tapusin ang pagbisita',
            leaveFeedback: 'Magbigay ng feedback',
          },
          safeToProceed: {
            continue: 'Magpatuloy',
            safeToProceed: 'Ligtas magpatuloy',
          },
        },
      },
    },
    index: {
      title: 'Maligayang pagdating',
      description: 'I-scan ang QR code sa iyong lokasyon upang magsimula.',
    },
    login: {
      errorTitle: 'Hindi inaasahang error',
      errorMessage: 'Nagkaroon ng hindi inaasahang error. Subukan muling i-scan ang QR code.',
    },
    unauthenticated: {
      welcome: {
        title: 'Maligayang pagdating sa {site}',
        description:
          'Bago namin ipakita ang anumang work order, kailangan naming tiyakin ang iyong detalye. I-click ang button sa ibaba upang magpatuloy.',
        next: 'Magpatuloy',
      },
      index: {
        errorTitle: 'Hindi inaasahang error',
        errorMessage: 'Nagkaroon ng hindi inaasahang error. Subukan muling i-scan ang QR code.',
      },
      contractor: {
        title: 'Sino ang iyong pinagtatrabahuhan?',
        contractor: 'Kontraktor',
        contractorLabel: 'Simulan ang pag-type ng pangalan ng iyong kumpanya',
        contractorHint: 'Kailangan mong maglagay ng 3 letra o higit pa upang makita ang resulta',
        defaultSelectPlaceholder: '--Pumili--',
        next: 'Susunod',
      },
      user: {
        title: 'Sino ka?',
        cancel: 'Kanselahin',
        createNewUserLabel: 'Hindi nakalista ang aking pangalan',
        existingUserLabel: 'Simulan ang pag-type ng iyong pangalan',
        existingUserHint: 'Kailangan mong maglagay ng 3 letra o higit pa upang makita ang resulta',
        newUserLabel: 'Ilagay ang iyong buong pangalan',
        next: 'Susunod',
        user: 'User',
      },
      verification: {
        methods: {
          add: {
            add: 'Magdagdag ng verification method',
            defaultSelectPlaceholder: '--Pumili--',
            emailLabel: 'Email',
            existingMethodWarning:
              'Mayroon ka nang nakabinbing request para sa verification method na ito na naghihintay ng pag-apruba ng admin. Ang pagdagdag ng bago ay papalit dito.',
            method: 'Paraan',
            methodLabel: 'Paraan',
            mobileCountryHint: 'Pumili ng country code',
            mobileCountryLabel: 'Country code ng mobile',
            mobileHint: 'Ilagay ang iyong mobile number',
            mobileLabel: 'Mobile',
            title: 'Magdagdag ng verification method',
          },
          confirm: {
            confirm: 'Kumpirmahin',
            description: 'Kumpirmahin ang iyong verification method upang magpatuloy.',
            label: 'Ilagay ang iyong code',
            resend: 'Ipadala muli',
            resendPrompt: 'Hindi nakatanggap ng code?',
            title: 'Kumpirmahin ang Verification Method',
          },
          confirmed: {
            description:
              'Aabisuhan ka kapag naaprubahan na ng iyong admin ang verification method na ito, at maaari mo na itong gamitin upang patunayan ang iyong pagkakakilanlan.',
            forceApproval: 'Hanggang maaprubahan, hindi ka makaka-access ng work order.',
            nonForceApproval:
              'Samantala, maaari kang magpatuloy na mag-access ng work order na may limitadong access.',
            nonForceApprovalButtonLabel: 'Magpatuloy na may limitadong access',
            title: 'Naghihintay ng pag-apruba',
          },
          addNew: 'Magdagdag ng bagong verification method',
          description:
            'Kailangan naming tiyakin ang iyong pagkakakilanlan upang mabigyan ka ng buong access sa work order.',
          email: 'Email',
          hint: 'Magpapadala kami ng link sa napiling verification method na magbibigay sa iyo ng buong access sa work order. Kung kailangan mong baguhin ang anumang verification method, makipag-ugnayan sa iyong administrator.',
          label: 'Pumili ng verification method',
          next: 'Susunod',
          pendingHint: 'Naghihintay ng pag-apruba mula sa iyong admin',
          sms: 'SMS',
          title: 'Verification',
        },
        optional: {
          hint: 'Ang pag-verify ng iyong detalye ay magbibigay sa iyo ng buong access sa work order',
          label: 'Gusto mo bang i-verify ang iyong detalye?',
          next: 'Susunod',
          no: 'Hindi',
          noHint:
            'Ayokong i-verify ang aking detalye at magpatuloy na may limitadong access sa work order',
          title: 'Verification',
          yes: 'Oo',
          yesHint: 'Gusto kong i-verify ang aking detalye at makuha ang buong access sa work order',
        },
        sent: {
          description:
            'Isang login link ang ipinadala sa {identifier}. I-click ang link upang tapusin ang iyong pag-login.',
          title: 'Ipinadala ang login link',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Kahapon',
      today: 'Ngayon',
      days: {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miyerkules',
        thursday: 'Huwebes',
        friday: 'Biyernes',
        saturday: 'Sabado',
        sunday: 'Linggo',
      },
      months: {
        january: 'Enero',
        february: 'Pebrero',
        march: 'Marso',
        april: 'Abril',
        may: 'Mayo',
        june: 'Hunyo',
        july: 'Hulyo',
        august: 'Agosto',
        september: 'Setyembre',
        october: 'Oktubre',
        november: 'Nobyembre',
        december: 'Disyembre',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'May nangyaring mali',
      message: 'Subukan muling i-scan ang QR code.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Hindi kilalang user',
      },
      none: 'Wala',
      types: {
        stateTransition: 'Nagbago ang status',
        contractorAssigned: 'Itinalaga ang kontraktor',
        engineerAssigned: 'Itinalaga ang engineer',
        serviceAssigned: 'Itinalaga ang serbisyo',
        priorityChanged: 'Nagbago ang prayoridad',
        actionableDateChanged: 'Nagbago ang actionable date',
        dueDateChanged: 'Nagbago ang due date',
        etaDateChanged: 'Nagbago ang tinatayang oras ng pagdating',
        spendLimitApproved: 'Inaprubahan ang spend limit',
        spendLimitCancelled: 'Kinansela ang request ng spend limit',
        spendLimitRejected: 'Tinanggihan ang spend limit',
        spendLimitRequested: 'Hiniling ang spend limit',
        jobSheetUploaded: 'Na-upload ang job sheet',
        slaAlertSent: 'Lumagpas sa SLA alert ang oras ng pagdalo',
        issuedWorkPermit: 'Ipinagkaloob ang work permit',
        requestForServiceSent: 'Ipinadala ang request para sa serbisyo',
        comment: 'Nagdagdag ng komento',
        unknown: 'Hindi kilalang event',
      },
      labels: {
        actionableDate: 'Actionable date',
        comment: 'Komento',
        file: 'File',
        contractor: 'Kontraktor',
        dueDate: 'Due date',
        etaDate: 'Tinatayang oras ng pagdating',
        engineer: 'Engineer',
        priority: 'Prayoridad',
        requestForService: 'Request para sa serbisyo',
        service: 'Serbisyo',
        spendLimit: 'Spend limit',
        status: 'Status',
        workPermit: 'Work permit',
      },
    },
  },
}
